<template lang="pug">
Card.selections-card
  template(#header)
    .title {{ $t('selections.bedrooms') }} 
  template(#content)
    SliderCustom(
      v-model="bedrooms"
      v-model:disable="disable"
      :step="1"
      :min="1"
      :max="5"
      :labels="['1', '2', '3', '4', '5+']"
      :disableText="$t('selections.anyBedrooms')"
      :ariaLabel="$t('selections.bedrooms')"
      @update:disable="updateBedrooms"
      @update:modelValue="resetTypeAndTypology"
    )
</template>
<script lang="ts">
import { ref } from "vue";
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import SliderCustom from "@/components/forms/components/SliderCustom.vue";

const DEF_NUM = 3;

export default defineComponent({
  name: "NumberOfBedrooms",
  components: {
    Card,
    SliderCustom,
  },
  setup() {
    const selections = useSelections();
    const { bedrooms } = storeToRefs(selections);
    const { resetTypeAndTypology } = selections;
    const disable = ref(false);
    if (bedrooms.value == undefined) bedrooms.value = DEF_NUM;

    function updateBedrooms(val: boolean) {
      if (val) {
        bedrooms.value = undefined;
      } else {
        bedrooms.value = DEF_NUM;
      }
    }

    return {
      bedrooms,
      updateBedrooms,
      resetTypeAndTypology,
      disable,
    };
  },
});
</script>
<style scoped lang="scss">
.slider-wrapper {
  padding: 2rem 0;
  margin-bottom: 2rem;

  &:deep(.p-disabled .p-slider-handle) {
    display: none;
  }
}

.checkbox-wrapper {
  padding: 2rem 0;
  display: flex;

  label {
    margin-left: 1rem;
    font-size: 1.1rem;
  }
}

.range-labels.range-labels {
  position: absolute;
  left: 0px;
  display: flex;
  justify-content: center;
  margin-top: 18px;
  width: 100%;
  padding: 0;
  list-style: none;

  li {
    position: relative;
    float: left;
    width: 100px;
    text-align: center;
    color: $form-slider-label-color;
    font-size: 0.875rem;
    cursor: pointer;

    &::before {
      position: absolute;
      top: -25px;
      right: 0;
      left: 0;
      content: "";
      margin: 0 auto;
      width: 9px;
      height: 9px;
      background: $form-slider-label-color;
      border-radius: 50%;
    }

    &.active::before {
      display: none;
    }

    &.selected::before {
      background: $secondary_color;
    }

    &.disabled {
      cursor: default;
      color: $background-color-disabled;

      &::before {
        background-color: $background-color-disabled;
        opacity: 0.6;
      }
    }

    @media screen and (max-width: 640px) {
      &:not(.active) span {
        display: none;
      }
    }
  }
}
</style>
